/**
 * Markdown formatting utilities
 */

/**
 * Converts value to string or JSON if not already a string
 */
export function stringifyIfNotString(v) {
  if (v == null) return "";
  if (typeof v === "string") return v;
  try {
    return JSON.stringify(v, null, 2);
  } catch (e) {
    return String(v);
  }
}

/**
 * Creates a code fence block
 */
export function codeFence(lang, body) {
  return "```" + (lang || "") + "\n" + (body || "") + "\n```";
}

/**
 * Pushes a heading to the lines array
 */
export function pushHeading(lines, text, level, style) {
  if (style === "setext" && (level === 1 || level === 2)) {
    lines.push(text);
    lines.push(level === 1 ? "=".repeat(text.length) : "-".repeat(text.length));
  } else {
    lines.push("#".repeat(level) + " " + text);
  }
  lines.push("");
}

/**
 * Collapses excessive whitespace in markdown
 */
export function collapseWhitespace(markdown) {
  // Trim lines and collapse 2+ blank lines → 1
  const lines = markdown.split(/\n/).map((l) => l.replace(/\s+$/g, ""));
  let out = [];
  let blankRun = 0;
  for (const l of lines) {
    if (l.trim() === "") {
      blankRun++;
      if (blankRun <= 1) out.push("");
    } else {
      blankRun = 0;
      out.push(l);
    }
  }
  return out.join("\n").trim() + "\n";
}

/**
 * Hard wraps text to a specified width
 */
export function hardWrap(text, width) {
  const out = [];
  for (const line of text.split("\n")) {
    if (line.length <= width || /^\s*```/.test(line)) {
      out.push(line);
      continue;
    }
    out.push(...wrapLine(line, width));
  }
  return out.join("\n");
}

/**
 * Wraps a single line to a specified width
 */
function wrapLine(line, width) {
  const words = line.split(/(\s+)/);
  const out = [];
  let cur = "";
  for (const w of words) {
    if ((cur + w).length > width && cur) {
      out.push(cur.trimEnd());
      cur = w.trimStart();
    } else {
      cur += w;
    }
  }
  if (cur) out.push(cur.trimEnd());
  return out;
}

/**
 * Makes value safe for YAML output
 */
export function safeYaml(v) {
  if (v == null) return "";
  const s = String(v);
  // Quote if contains special chars
  if (/[:\-#?&*!@{}[\],]|^\s|\s$|^$/.test(s)) return JSON.stringify(s);
  return s;
}
